/*
  Keeps the announcement marquee seamless on wide screens.
  Each group must be at least as wide as the bar, otherwise a gap shows while it scrolls.
  The markup already ships with enough repeats for most screens; this adds more when needed.
*/
if (!customElements.get('announcement-marquee')) {
  class AnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this.fill = this.fill.bind(this);
      this.resizeObserver = new ResizeObserver(this.fill);
      this.resizeObserver.observe(this);
      this.fill();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.fill);
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }

    fill() {
      const groups = this.querySelectorAll('.announcement-marquee__group');
      if (groups.length < 2) return;
      const [first, second] = groups;

      // Reduced motion hides the second group and shows the messages once
      if (getComputedStyle(second).display === 'none') return;

      const template = first.lastElementChild;
      if (!template) return;

      let added = 0;
      while (first.offsetWidth < this.clientWidth && added < 30) {
        first.append(this.copyOf(template));
        second.append(this.copyOf(template));
        added += 1;
      }
    }

    copyOf(set) {
      const copy = set.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      copy.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
      copy.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      return copy;
    }
  }

  customElements.define('announcement-marquee', AnnouncementMarquee);
}
